<template>
  <Fragment>
    <div class="row mt-4 mt-md-5">
      <div class="col text-center">
        <h2 class="font-main font-weight-bold roi-heading-small">
          <span>
            <img :src="step.imagePath" :alt="step.displayName" />
          </span>
          {{ step.displayName }}
        </h2>
      </div>
    </div>

    <div class="row mt-2 mt-md-3 mt-lg-4">
      <div class="col-12 mx-auto">
        <form>
          <slot />
        </form>
      </div>
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-frag';

export default {
  name: 'ReviewStepContainer',

  components: { Fragment },

  props: {
    /** @type {import('vue').PropOptions<Step>} */
    step: {
      type: Object,
      required: true,
    },
  },
};

/** @typedef {import('../../store/state').Step} Step */
</script>
